import { Mode } from './Mode.js';
/**
 * QRData
 *
 * @author Kazuhiko Arase
 */
export class QRData {
    mode;
    data;
    constructor(mode, data) {
        this.mode = mode;
        this.data = data;
    }
    getMode() {
        return this.mode;
    }
    getData() {
        return this.data;
    }
    getLengthInBits(typeNumber) {
        if (1 <= typeNumber && typeNumber < 10) {
            // 1 - 9
            switch (this.mode) {
                case Mode.MODE_NUMBER:
                    return 10;
                case Mode.MODE_ALPHA_NUM:
                    return 9;
                case Mode.MODE_8BIT_BYTE:
                    return 8;
                case Mode.MODE_KANJI:
                    return 8;
                default:
                    throw new Error('mode:' + this.mode);
            }
        }
        else if (typeNumber < 27) {
            // 10 - 26
            switch (this.mode) {
                case Mode.MODE_NUMBER:
                    return 12;
                case Mode.MODE_ALPHA_NUM:
                    return 11;
                case Mode.MODE_8BIT_BYTE:
                    return 16;
                case Mode.MODE_KANJI:
                    return 10;
                default:
                    throw new Error('mode:' + this.mode);
            }
        }
        else if (typeNumber < 41) {
            // 27 - 40
            switch (this.mode) {
                case Mode.MODE_NUMBER:
                    return 14;
                case Mode.MODE_ALPHA_NUM:
                    return 13;
                case Mode.MODE_8BIT_BYTE:
                    return 16;
                case Mode.MODE_KANJI:
                    return 12;
                default:
                    throw new Error('mode:' + this.mode);
            }
        }
        else {
            throw new Error('typeNumber:' + typeNumber);
        }
    }
}
//# sourceMappingURL=QRData.js.map